<nx-card class="card-width">
  <h3 nxHeadline="subsection-small" class="card-title">
    {{ data?.eventName }}
  </h3>

  <p nxCopytext="normal" class="card-content-align badge-margin">
    <nx-badge class="badge-color">{{ data?.hostedBy }}</nx-badge>
  </p>
  <p nxCopytext="normal" class="card-content-align margin-0">
    <nx-icon name="calendar" size="s" class="icon-size"></nx-icon>
    <span class="card-text">
      {{ formatDate(data?.startDate, "DD MMM YYYY") }} -
      {{ formatDate(data?.endDate, "DD MMM YYYY") }}
    </span>
  </p>

  <p nxCopytext="normal" class="card-content-align margin-0">
    <nx-icon name="clock-o" size="s" class="icon-size"></nx-icon>
    <span class="card-text">
      {{ formatDate(data?.startDate, "h:mm a") }} -
      {{ formatDate(data?.endDate, "h:mm a") }}
    </span>
  </p>
  <p nxCopytext="normal" class="card-content-align margin-0">
    <nx-icon name="location" size="s" class="icon-size"></nx-icon>
    <span class="card-text">
      {{ data?.venue }}
    </span>
  </p>
  <p
    [ngClass]="{
      'display-none': !data?.description,
      'bottom-line': data?.description,
    }"
  ></p>
  <div class="description-text">
    {{ data?.description }}
  </div>
</nx-card>
